import React, { useState, useEffect } from 'react';
import HeadingArea from '../../general/HeadingArea';
import { FaCheck } from 'react-icons/fa';
import ResponseMsg2 from '../../general/ResponseMsg2';
import { AiOutlinePlusCircle, AiOutlineMinusCircle } from 'react-icons/ai';
import { RiDeleteBin6Line } from 'react-icons/ri';

const Topic = ({ setLoading, userData }) => {
  const [classes, setClasses] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState('');
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState('');
  const [titles, setTitles] = useState(['']); // Dynamic title inputs
  const [response2, setResponse2] = useState({ message: '', status: '' });
  const [myTopic, setMyTopic] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState([]);
const [lessons, setLessons] = useState([]);
const [selectedLesson, setSelectedLesson] = useState('');

  // Fetch Classes
  const fetchClasses = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-classes');
      if (response.ok) {
        const data = await response.json();
        setClasses(data);
      } else {
        console.error('Failed to fetch class');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch Assigned Subjects
  const fetchAssignSubject = async (classId) => {
    if (!classId) return;
    setLoading(true);
    try {
      const res = await fetch(`https://api.kcian.in/fetch-assigned-subject?class_id=${classId}`);
      if (res.ok) {
        const data = await res.json();
        if (data.length > 0) {
          const uniqueSubjectsMap = new Map();
          data.forEach(item => {
            if (!uniqueSubjectsMap.has(item.sub_id)) {
              uniqueSubjectsMap.set(item.sub_id, item);
            }
          });
          const uniqueSubjects = Array.from(uniqueSubjectsMap.values());
          setSubjects(uniqueSubjects);
          setResponse2({ message: 'Subjects Loaded.', status: 'success' });
        } else {
          setSubjects([]);
          setResponse2({ message: 'No subjects assigned to this class.', status: 'error' });
        }
      } else {
        setSubjects([]);
        setResponse2({ message: 'Error fetching subjects.', status: 'error' });
      }
    } catch (error) {
      console.error('Error fetching assigned subjects:', error);
    } finally {
      setLoading(false);
      setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    }
  };

  // Handlers for dynamic titles
  const addTitleField = () => setTitles([...titles, '']);
  const removeTitleField = (index) => setTitles(titles.filter((_, i) => i !== index));
  const handleTitleChange = (index, value) => {
    const newTitles = [...titles];
    newTitles[index] = value;
    setTitles(newTitles);
  };

  // Handle Save
  const handleSubmit = async (e) => {
    e.preventDefault();

if (!selectedClassId || !selectedSubject || !selectedLesson || titles.some(title => !title.trim())) {
  setResponse2({ message: 'All fields are required.', status: 'error' });
  return;
}

    const payload = titles.map(title => ({
      plan_id: selectedLesson,
      topic_name: title.trim(),
    }));

    
    try {
      setLoading(true);
      const res = await fetch('https://api.kcian.in/add-lesson-topic', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        setResponse2({ message: 'Topic(s) Added Successfully.', status: 'success' });
        setTitles(['']);
      } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
      }
    } catch (err) {
      console.error('Save error:', err);
    } finally {
      setLoading(false);
      setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    }
  };

  // Effects
  useEffect(() => {
    fetchClasses();
  }, []);

  useEffect(() => {
    if (selectedClassId) {
      fetchAssignSubject(selectedClassId);
    } else {
      setSubjects([]);
    }
  }, [selectedClassId]);


const fetchLesson = async () => {
  if (!selectedClassId || !selectedSubject) {
    setResponse2({ message: 'Please select Class and Subject before fetching lessons.', status: 'error' });
    return;
  }

  try {
    setLoading(true);
    const res = await fetch(`https://api.kcian.in/fetch-lesson-plan?class_id=${selectedClassId}&sub_id=${selectedSubject}`);

    if (res.ok) {
      const data = await res.json();

      if (data.length > 0) {
        setLessons(data);           // <-- Populate lesson dropdown
        setResponse2({ message: 'Lessons Fetched Successfully', status: 'success' });
      } else {
        setLessons([]);
        setResponse2({ message: 'No Lessons Found for this Class & Subject.', status: 'error' });
      }
    } else {
      setResponse2({ message: 'Something went wrong. Try again.', status: 'error' });
    }
  } catch (error) {
    console.error('Fetch lesson error:', error);
  } finally {
    setLoading(false);
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
  }
};



const handleShowDelete = (cls) => {
    setSelectedPlan(cls);
    setShowDelete(true);
}


              const handleDelete = async (topicId) => {
    try {
      const response = await fetch(`https://api.kcian.in/delete-lesson-topic/${topicId}`, {
        method: 'DELETE',
      });


      if (response.ok) {
setMyTopic((prevData) => prevData.filter((product) => product.id !== topicId));
        setShowDelete(false);
        setResponse2({ message: 'Topic Removed successfully!', status: 'success' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);
      } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);   
      }
    } catch (error) {
      console.error('Error deleting fee particular:', error);
    }
  };


  const fetchTopic = async () => {
  if (!selectedLesson) {
    setResponse2({ message: 'Please select Lesson before searching', status: 'error' });
    return;
  }

  try {
    setLoading(true);
    const res = await fetch(`https://api.kcian.in/fetch-lesson-topic?plan_id=${selectedLesson}`);

    if (res.ok) {
      const data = await res.json();

      if(data.length > 0){
setMyTopic(data);
      setResponse2({ message: 'Topic Fetched Successfully', status: 'success' });
      }
      else {
        setMyTopic([]);
        setResponse2({ message: 'No Topic Added to this Lesson Plan.', status: 'error' });
      }
    } else {
      setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
    }
  } catch (error) {
    console.error('Fetch plan error:', error);
  } finally {
    setLoading(false);
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
  }
};



  return (
    <>
    <section className="py-4">
      <div className="px-4">
        <HeadingArea message1="Lesson Plan" message2="Topic" />
        {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

        <div className='row'>
          {/* Left Side Form */}
          <div className='col-xl-3 col-lg-4 col-md-5 col-12 my-2'>
            <form onSubmit={handleSubmit}>
              <div className="profile-card">
                <p className="profile-heading">Add Topic</p>

                <div className='profile-input-area mb-4'>
                  <label className='profile-badge'>Class</label>
                  <select
                    className='profile-input'
                    value={selectedClassId}
                    onChange={(e) => setSelectedClassId(e.target.value)}
required
>
                    <option value=''>-- Select Class --</option>
                    {classes.map(cls => (
                      <option key={cls.id} value={cls.id}>
                        {cls.class_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className='profile-input-area mb-4'>
                  <label className='profile-badge'>Subject</label>
                  <select
                    className='profile-input'
                    value={selectedSubject}
                    onChange={(e) => setSelectedSubject(e.target.value)}
                    disabled={subjects.length === 0}
                    required
                  >
                    <option value=''>-- Select Subject --</option>
                    {subjects.map(sub => (
                      <option key={sub.id} value={sub.sub_id}>
                        {sub.sub_name} ({sub.sub_type}) ({sub.sub_code})
                      </option>
                    ))}
                  </select>
                </div>

                <button className='profile-btn2 mb-4' onClick={() => fetchLesson()}>Fetch Lesson</button>

{lessons.length > 0 && (
  <div className='profile-input-area mb-4'>
    <label className='profile-badge'>Lesson</label>
    <select
      className='profile-input'
      value={selectedLesson}
      onChange={(e) => setSelectedLesson(e.target.value)}
      required
    >
      <option value=''>-- Select Lesson --</option>
      {lessons.map((lesson) => (
        <option key={lesson.id} value={lesson.id}>
          {lesson.lesson_name}
        </option>
      ))}
    </select>
  </div>
)}


              </div>


              <div className='profile-card mt-2'>
                <p className='profile-heading'>Add Topic Name</p>

                {titles.map((title, index) => (
                  <div className="mb-3 d-flex align-items-center" key={index}>
                    <div className='profile-input-area w-100'>
                    <input
                      type="text"
                      value={title}
                      onChange={(e) => handleTitleChange(index, e.target.value)}
                      placeholder="Enter Topic"
                      className="profile-input"
                      required
                    />
                    </div>
                    {titles.length > 1 && (
                      <AiOutlineMinusCircle
                        size={26}
                        className="text-danger cursor-pointer ms-2"
                        onClick={() => removeTitleField(index)}
                      />
                    )}
                  </div>
                ))}

                <div className='text-end'>
                  <button
                    type="button"
                    className="border-0 bg-transparent cursor-pointer"
                    onClick={addTitleField}
                  >
                    <AiOutlinePlusCircle size={26} />
                  </button>
                </div>

                <div className='text-center'>
                  <button type='submit' className='profile-btn'>
                    <FaCheck /> Save
                  </button>
                </div>
              </div>
            </form>
          </div>

          {/* Right Side List */}
          <div className='col-xl-9 col-lg-8 col-md-7 col-12 my-2 h-100'>
            <div className='profile-card'>
              <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
                <span className="profile-heading me-3">Topic List</span>

<button className='profile-btn2' onClick={() => fetchTopic()}>Fetch Topic</button>
              </div>

              <div className='table-responsive mt-4'>
                <table className='w-100'>
                  <thead className='account-thead'>
                    <tr>
                      <th className='rounded-start-4'>S No</th>
                      <th>Class</th>
                      <th>Subject</th>
                      <th>Lesson</th>
                      <th>Topic</th>
                      {/* {userData.role == 'SupAdmin' && */}
                      <th>Added By</th>
                      <th className='rounded-end-4'>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {myTopic.map((topic, index) => (
                    <tr className='account-tr'>
                      <td>{index + 1}</td>
                      <td>{topic.class_name}</td>
                      <td>{topic.sub_name}({topic.sub_type})</td>
                      <td>{topic.lesson_name}</td>
                      <td>{topic.topic_name}</td>
                                                                  {/* {userData.role == 'SupAdmin' && */}
                      <td>{topic.addedby_name} ({topic.designation})</td>

{(userData.role == 'SupAdmin' || userData.user_id == topic.added_by)
?    <td><RiDeleteBin6Line className='account-icon2' title='Remove' onClick={() => handleShowDelete(topic)} /></td>
    : <td>--</td>}
                    </tr>
                    ))}

                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>


          {showDelete && (
  <>
        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <p className='ins-dialog-heading text-danger'>Remove This Lesson Topic!</p>

<div className='table-responsive'>
<table className='w-100'>

<thead className='account-thead'>
    <th className='rounded-start-4'>Class</th>
    <th>Subject</th>
    <th>Lesson</th>
    <th className='rounded-end-4'>Topic</th>
</thead>

<tr className='account-tr'>
                      <td>{selectedPlan.class_name}</td>
                      <td>{selectedPlan.sub_name}({selectedPlan.sub_type})</td>
                      <td>{selectedPlan.lesson_name}</td>
                      <td>{selectedPlan.topic_name}</td>
                      </tr>

</table>
</div>

<p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Topic of this Lesson Plan will be permanently removed.</p>

            <button className='profile-btn me-2' onClick={() => handleDelete(selectedPlan.id)}>Remove</button>
            <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


    </div>
  </section>
  </>
)}

    </>
  );
};

export default Topic;
